<div>
  <app-dynamic-form [data]="data" [descriptorMap]="descriptorMap"></app-dynamic-form>
</div>
